import PropTypes from "prop-types";

const Intro = ({ data }) => {
    return (
        <div
            className="intro-section"
            style={{ position: 'relative' }}
        >
            <video
                autoPlay
                loop
                muted
                playsInline
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    top: 0,
                    left: 0,
                    objectFit: 'cover',
                    zIndex: 0
                }}
            >
                <source src={`${process.env.PUBLIC_URL}/img/sun.mp4`} type="video/mp4" />
            </video>
            <div className="container" style={{ position: 'relative', zIndex: 1 }}>
                <div className="row">
                    <div className="col-12">
                        <div className="slider-content">
                            <h2 className="title" dangerouslySetInnerHTML={{ __html: data.title }} />
                            <p className="text">{data.subTitle}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

Intro.propTypes = {
    data: PropTypes.object,
};

export default Intro;
